import { selectorFamily, atom } from 'recoil';
import { InvoicePassingsService } from 'api';
export const passingsForInvoicePagination = atom({
  key: 'passingsForInvoicePagination',
  default: {
    max: 10,
    offset: 0
  }
});
export const passingsForInvoiceObeNumber = atom({
  key: 'passingsForInvoiceObeNumber',
  default: null
});
export const getPassingsForInvoice = selectorFamily({
  key: 'getPassingsForInvoice',
  get: invoiceId => async ({
    get
  }) => {
    let result = {};
    if (!invoiceId) return result;
    const paginationProps = get(passingsForInvoicePagination);
    const obeNumber = get(passingsForInvoiceObeNumber);
    try {
      result = await InvoicePassingsService.getPassingsByInvoiceId({
        invoiceId,
        body: {
          ...paginationProps,
          obeNumber: obeNumber ?? undefined
        }
      });
    } catch (e) {
      console.error(e);
    }
    return result;
  }
});